import "./Paper_module.css";
const Paper_module = {
    paper: "paper__e49c57ec5f37ff37",
    noMargin: "noMargin__e49c57ec5f37ff37",
    rounded: "rounded__e49c57ec5f37ff37",
    shadow: "shadow__e49c57ec5f37ff37"
};
export { Paper_module as default };
